import { LocalityData } from '../components/community/sections/locality/localityTypes';
import localLocalityData from '../components/community/sections/locality/nearbyLocalities.json';

const GOOGLE_API_KEY = 'AIzaSyCoOBoxdyl5-4sHLdNr_Z8a0SrEsSqqu_s';

export const fetchLocalityData = async (
  fileId: string
): Promise<LocalityData> => {
  if (!GOOGLE_API_KEY) {
    console.warn('🔑 Google API key not found, using local locality data');
    return localLocalityData as LocalityData;
  }

  try {
    // Create AbortController for timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000); // 3 second timeout

    const response = await fetch(
      `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media&key=${GOOGLE_API_KEY}`,
      {
        signal: controller.signal,
      }
    );

    clearTimeout(timeoutId); // Clear timeout if request completes

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('📍 Successfully loaded locality data from Google Drive');
    return data as LocalityData;
  } catch (error) {
    console.warn(
      '⚠️ Error fetching locality data from Drive, using local data:',
      error
    );
    return localLocalityData as LocalityData;
  }
};
